import React from 'react';

import {
  string,
  bool,
  shape,
  func,
  oneOf,
  oneOfType,
  arrayOf,
  node
} from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';
import Button from '../../button/Button';
import Icon from '../../icon/Icon';

import './MessageBox.scss';

const typesIcon = {
  success: 'smile',
  primary: 'calendar',
  warning: 'warnTriangle',
  error: 'frown'
};

const typesClass = {
  success: '-success',
  primary: '-primary',
  warning: '-warning',
  error: '-error'
};

/**
 * @deprecated
 */
export default class MessageBox extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      closed: false
    };
  }

  handleClose = () => {
    const { onClose } = this.props;

    if (onClose) {
      onClose();
    }

    this.setState({ closed: true });
  };

  render() {
    const {
      type,
      withIcon,
      closable,
      style,
      id,
      className,
      children
    } = this.props;

    const { handleClose } = this;
    const { closed } = this.state;

    const messageIcon = (
      <Icon className="message-icon" icon={typesIcon[type]} />
    );

    const classNames = ClassNames('Message-box', className, typesClass[type], {
      closable,
      hidden: closed
    });

    return (
      <div className={classNames} style={style} id={id}>
        {withIcon && messageIcon}
        <span className="message">{children}</span>
        <Button className="close-button" onClick={handleClose}>
          <Icon className="close-icon" icon="timesCircle" size="sm" />
        </Button>
      </div>
    );
  }
}

MessageBox.propTypes = {
  type: oneOf(['success', 'primary', 'warning', 'error']),
  withIcon: bool,
  closable: bool,
  style: shape({}),
  id: string,
  className: string,
  onClose: func,
  children: oneOfType([arrayOf(node), node]).isRequired
};

MessageBox.defaultProps = {
  type: 'success',
  withIcon: false,
  closable: false,
  style: {},
  id: undefined,
  className: undefined
};
